const OctaneQuiz = class extends HTMLElement {
  constructor() {
    super()

    this.newsletterContent = this.querySelector('[data-newsletter-content]')
    window.dailyProtein = 0
  }

  connectedCallback() {
    document.addEventListener('octane.quiz.completed', (e) => {
      this.newsletterContent.classList.remove('hidden')
      this.resultsPageInit(e)
    }, false)
  }

  async resultsPageInit (e) {
    this.processAnswers(e.detail.answers)
  }

  processAnswers(answers) {
    const data = {
      age: Number(answers.Age.replace(/\D/g, '')),
      weight: Number(answers.Weight.replace(/\D/g, '')),
      height: Number(answers.Height.replace(/\D/g, '')),
      gender: answers.Gender,
      activityLevel: answers.Activity,
      routine: answers.Routine,
      goal: answers.Goal
    }

    window.dailyProtein = this.calculateDailyProtein(data)

    const badge = this.querySelector('[data-protein-amount]')
    badge.innerHTML = `${window.dailyProtein}g`
  }

  calculateDailyProtein ({
    age,
    weight,
    height,
    gender, // 'Male' or 'Female'
    activityLevel, // 'Sedentary', 'Light', 'Moderate', 'High'
    routine, // '0-2', '3-5', '6+', 'Very active'
    goal // 'Lose', 'Add', 'Maintain'
  }) {
    // Step 1: Calculate BMR using Mifflin-St Jeor (Imperial)
    const bmr = gender === 'Male'
      ? (4.536 * weight) + (15.88 * height) - (5 * age) + 5
      : (4.536 * weight) + (15.88 * height) - (5 * age) - 161;

    // Step 2: Get Activity Multiplier
    const activityMultipliers = {
      Sedentary: 1.2,
      Light: 1.375,
      Moderate: 1.55,
      High: 1.725,
    };
    const AM = activityMultipliers[activityLevel] || 1.2;

    // Workout multiplier
    let WM = 1.10;
    if (routine === '0-2') WM = 1.0;
    if (routine === '3-5') WM = 1.05;

    const TDEE = bmr * AM * WM;

    // Step 3: Adjust TDEE for goal
    let adjustedCalories = TDEE;
    let proteinRatio = 0.30; // Default for Maintain/Add

    if (goal === 'Lose') {
      adjustedCalories = TDEE * 0.80;
      proteinRatio = 0.40;
    } else if (goal === 'Add') {
      adjustedCalories = TDEE + 500;
    }

    // Step 4: Calculate protein grams (1g protein = 4 kcal)
    const proteinCalories = adjustedCalories * proteinRatio;
    const proteinGrams = proteinCalories / 4;

    return Math.round(proteinGrams);
  }
}

if (typeof window.customElements.get('octane-quiz') === 'undefined') {
  window.customElements.define('octane-quiz', OctaneQuiz)
}

const ProteinNewsletterForm = class extends HTMLElement {
  constructor() {
    super()

    this.apiKey = this.dataset.apiKey
    this.listId = this.dataset.listId
    this.type = this.dataset.type

    this.form = this.querySelector('[data-newsletter-form]')
    this.emailField = this.querySelector('input[name="email"]')
    this.fields = this.querySelectorAll('.fieldset-with-submit')

    this.success = this.querySelector('[data-form-success]')
    this.error = this.querySelector('[data-form-error]')

    this.protein = 0
  }

  connectedCallback () {
    this.form && this.form.addEventListener('submit', (e) => {
      e.preventDefault()

      if (!this.emailField.checkValidity()) {
        this.error.classList.remove('hide')
        this.error.innerHTML = `<p>Please enter a valid email address.</p>`
        return
      }

      this.submitForm()
    })
  }

  async submitForm() {
    const formData = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Protein Calculator',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: this.emailField.value,
                properties: {
                  protein: window.dailyProtein
                }
              }
            }
          }
        },
        subscriptions: {
          email: {
            marketing: {
              consent: 'SUBSCRIBED'
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: this.listId
            }
          }
        }
      }
    }

    const res = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${this.apiKey}`, {
      method: 'POST',
      headers: {
        revision: '2024-02-15',
        'content-type': 'application/json'
      },
      body: JSON.stringify(formData)
    })

    this.success && this.success.classList.toggle('hidden', !res.ok)
    this.fields.forEach((field) => {
      field.classList.toggle('hidden', res.ok)
    })

    if (this.error) {
      this.error.classList.toggle('hidden', res.ok)
      this.error.innerHTML = `${res.statusText || 'There was an error'}`
    }

    if (!res.ok) { return }
    const successEvent = new CustomEvent('submit_success', {
      detail: res
    })

    this.dispatchEvent(successEvent)
  }
}

if (typeof window.customElements.get('protein-newsletter-form') === 'undefined') {
  window.customElements.define('protein-newsletter-form', ProteinNewsletterForm)
}

